import {useEffect, useState, useRef} from 'react';
import WidgetPopUp from './WidgetPopUp.js';
import Effect from './Effect.js';
import EffectGridPopup from './EffectGridPopup.js';

const colors = {
    0: "green",
    1: "orange",
    2: "brown",
}

const options = ['∞', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']

const EffectGrid = ({title, imgMap, type, effects, updateCreatureEffects, duration, setDuration}) => {
    return (
        <>
            <div style={{display: "flex", width: "100%", justifyContent: 'space-between'}}>
                <div className="effectTitles" style={{opacity: 0}}><b>{title}</b></div>
                <div className="effectTitles"><b>{title}</b></div>
                <div style={{display: "flex", alignItems: 'center'}}>
                    <i className='editBlockTitle'>Duration </i>
                    <div className='editBlock'>
                        <select className='editBlockInput' 
                            style={{width: 'fit-content'}}
                            value={duration} 
                            onChange={(e) => setDuration(e.target.value)}
                        >
                            {options.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

            </div>
            <div className="effectsBar" onClick={(event) => event.stopPropagation()} >
                {Object.entries(imgMap).map(([effectName, image]) => (
                    <WidgetPopUp 
                        trigger={
                            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}} key={effectName}>
                                <Effect 
                                    key={effectName} 
                                    currentEffects={effects} 
                                    updateCreatureEffects={updateCreatureEffects} 
                                    effectName={effectName} 
                                    image={image}
                                    type={type}
                                />
                            </div>
                        }
                        popUp={
                            <EffectGridPopup effectName={effectName.replace('Condition', '').trim()} type={type} /> 
                        }
                        popOverClass={'effectHoverPopup'}
                        alignOffset={-4}
                        sideOffset={8}
                        openOnHover={true}
                        delay={800}
                    />

                ))}
            </div>
        </>
  );
}

export default EffectGrid;